import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "./Logo";
import { Badge, Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import "./Header.scss";
import SettingDropdown from "./SettingDropdown";
import { useDispatch, useSelector } from "react-redux";
import { processDocsLocal } from "../../context/actions/document";
import { SocketContext } from "../../context/actions/socket";
import { logout } from "../../context/actions/user";
import { toast } from "react-toastify";
import { toasterConfig } from "../../utils/constants";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { getNotificationDetails } from "../../context/actions/notificationDetails";
import Marquee from "react-fast-marquee";
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { NumberParsingError } from "pdf-lib";
import NotificationDropdown from './NotificationDropdown';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { resetReadOnlyDoc } from "../../context/actions/document"
// import { faBell } from "@fortawesome/free-solid-svg-icons";
// import useDarkMode from 'use-dark-mode';

const MySwal = withReactContent(Swal)
const Header = ({ className = "" }) => {
  const [notificationData, setNotificationData] = useState([])
  const dispatch = useDispatch();
  const history = useHistory();
  const enableButton = useSelector((state) => state.document.enableButton);
  const selectedFile = useSelector((state) => state.document.fileData);
  const userDetail = useSelector((state) => state?.user?.user);
  // const darkMode = useDarkMode(false);

  const backClick = () => {
    // if(selectedFile?.reading_by === userDetail?._id && selectedFile?.read_only){
		// 	dispatch(resetReadOnlyDoc({ docId: selectedFile._id}, (result) => {
		// 		if(result){
    //       backendSocket.emit('check-doc-status', selectedFile)
		// 			console.log(selectedFile._id," doc reset")
		// 		}
		// 	}))
		// }
    history.push("/upload-file");
  };
  const isNotificationDisabled = useSelector((state) => state?.user?.isNotificationDisabled);

  const [modal, setModal] = useState(false);
  const [tag, setTag] = useState({});
  const userPermissions = useSelector(

    (state) => state?.user?.user?.roles?.permissions

  );

  const [notificationDetails, setNotificationDetails] = useState([])

  const toggle = (e) => { setModal(!modal) }

  const processDocs = () => {
    dispatch({ type: "ENABLE BUTTON", data: false });
    dispatch(
      processDocsLocal((res) => {
        if (res.errors) {
          dispatch({ type: "ENABLE BUTTON", data: true });
        }
      })
    );
  };

  const { backendSocket } = useContext(SocketContext);

  // if (res && res?.data?.docId === document.getElementById('veryUniqueId')?.value) {  // js get element
  // 	if (res?.data?.count && res?.data?.count != 0)
  // 		dispatch({ type: "SET_VIEW_RECORD", data: true })
  // 	else
  // 		dispatch({ type: "SET_VIEW_RECORD", data: false })
  // }

  useEffect(() => {
    dispatch({ type: "ISLOADING", data: false });
    backendSocket.off("isLogout").on("isLogout", (res, err) => {
      if (res) {
        if (res && res?.data === userDetail._id) {
          console.log("logout is hitting");
          localStorage.removeItem("_expiredTime");
          localStorage.removeItem("TOKEN");
          localStorage.setItem("LOGOUT", true);
          dispatch({ type: "LOGOUT", data: {} });
          dispatch({ type: "SET_TEMPDATA", data: {} });
          toast.dismiss();
          toast.success("Logout Successful", toasterConfig);
          MySwal.close();
          history.push('/login')
        }
      }
    });
  }, []);

  useEffect(() => {
    if (!isNotificationDisabled) {
      dispatch(
        getNotificationDetails({}, (res) => {
          setNotificationData(res.data)

        })
      );
    }

  }, [])

  function getPriorityColor(priority) {

	return priority === 'Information'
		? 'info'
		: priority === 'Success'
			? 'success'
			: priority === 'Warning'
				? 'warning'
				: priority === 'Important'
					? 'danger'
					: 'default';
}


  useEffect(() => {
    backendSocket.off("isSubadminLogout").on("isSubadminLogout", (res, err) => {
      console.log("SubadminLogin", res)
      if (res) {
        if (res.data && res.data === userDetail._id) {
          if (
            res.organization !== userDetail.organization ||
            res.role !== userDetail.role
          ) {
            dispatch({ type: "ISLOADING", data: false });
            dispatch({ type: "LOGOUT", data: {} });
            dispatch({ type: "SET_TEMPDATA", data: {} });
            MySwal.close();
            history.push('/login')
          }
        }
      }
    });
  }, []);

  const location = useLocation();

  const handleDisabled = () => {
    dispatch({ type: 'NOTIFICATION_DISABLE', payload: true })
    setNotificationData([])
  }




  return (
    <>
      <div className={`header d-flex align-items-center ${className}`}>
        <Logo />

        {notificationData?.length ? <div className="notification-animation d-flex align-items-center overflow-hidden flex-fill">
          <Marquee pauseOnHover={true}>
            {notificationData.map((data, index) => (<>

              <div className="move d-inline-flex align-items-center">


                <label className={`text-${getPriorityColor(data.priority)}`}>
                  {data.priority} </label>
                <span>
                  {data.title}
                </span>
                <Button color="link" className="view-btn" onClick={() => { toggle(); setNotificationDetails(data) }}>View Detail</Button>

              </div>
            </>))}
          </Marquee>
          <Button onClick={handleDisabled} color="link" className="dismiss-btn btn-outline-danger">Dismiss</Button>
        </div> : ''
        }
        <div className="right-col ms-auto d-flex align-items-center flex-shrink-0">
          {process.env.REACT_APP_ENV == "local" &&
            (userDetail?.role == "business" || userDetail?.role == "operator") ? (
            <Button
              disabled={!enableButton}
              color="link"
              className={`upload-file-btn active`}
              onClick={() => processDocs()}
            >
              Process Documents
            </Button>
          ) : null}

          {userDetail?.role == "business" ? (
            <Button
              color="link"
              className={`upload-file-btn ${location.pathname.includes("upload-file") ? "active" : "link"
                }`}
              onClick={() => backClick()}
            >
              Upload
            </Button>
          ) : userPermissions?.some(
            (permission) => permission?.SLUG == "document_management"
          ) ? (
            <Button
              color="link"
              className={`upload-file-btn ${location.pathname.includes("upload-file") ? "active" : "link"
                }`}
              onClick={() => backClick()}
            >
              Upload
            </Button>
          ) : (
            ""
          )}

          {/* <NotificationDropdown /> */}
          {/* <MessageDropdown /> */}
          <SettingDropdown />
        </div>
      </div>



      {/* <div>
				<Modal
					isOpen={modal}
					className="notification-modal-wrapper"
					size="lg"
				>
					<ModalHeader>
						<div className="logo-wrapper d-flex align-items-center justify-content-center flex-fill">
							<div className="pic">
								<img
									className="img-fluid"
									src={require("../../assets/img/user-logo1.png")}
									alt="Logo"
								/>
							</div>
							<div className="line d-inline-flex"></div>
							<div className="pic">
								<img
									className="img-fluid"
									src={require("../../assets/img/app-logo.png")}
									alt="Logo"
								/>
							</div>
						</div>
						<Button color="link" onClick={toggle} className="close-btn">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="34"
								height="34"
								viewBox="0 0 34 34"
							>
								<g data-name="Group 651" transform="translate(-1535 -134)">
									<g
										fill="#fff"
										stroke="#000"
										strokeWidth="2"
										data-name="Ellipse 30"
										opacity="0.3"
										transform="translate(1535 134)"
									>
										<circle cx="17" cy="17" r="17" stroke="none"></circle>
										<circle cx="17" cy="17" r="16" fill="none"></circle>
									</g>
									<path
										d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
										data-name="Icon ionic-ios-close"
										opacity="0.3"
										transform="translate(1534.289 132.789)"
									></path>
								</g>
							</svg>
						</Button>
					</ModalHeader>
					<ModalBody className="notification-blc">
						{console.log("notificationDetails", notificationDetails)}
						<h2>{notificationDetails?.title?.replace(/<[^>]+>/g, '')}</h2>
						<div className="desc-blc">
							<p>
								{notificationDetails?.description?.replace(/<[^>]+>/g, '')}
							</p>
						</div>
					</ModalBody>
				</Modal>


			</div> */}
      <div>
        <Modal
          isOpen={modal}
          className="notification-modal-wrapper"
          size="lg"
        >
          <ModalHeader>
            <div className="logo-wrapper d-flex align-items-center justify-content-center flex-fill">
              <div className="pic">
                <img
                  className="img-fluid"

                  src={require("../../assets/img/user-logo1.png")}
                  alt="Logo"

                />
              </div>
              <div className="line d-inline-flex"></div>
              <div className="pic">
                <img
                  className="img-fluid"
                  src={require("../../assets/img/app-logo.png")}
                  alt="Logo"
                />
              </div>
            </div>
            <Button color="link" onClick={() => toggle(null)} className="close-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
              >
                <g data-name="Group 651" transform="translate(-1535 -134)">
                  <g
                    fill="#fff"
                    stroke="#000"
                    strokeWidth="2"
                    data-name="Ellipse 30"
                    opacity="0.3"
                    transform="translate(1535 134)"
                  >
                    <circle cx="17" cy="17" r="17" stroke="none"></circle>
                    <circle cx="17" cy="17" r="16" fill="none"></circle>
                  </g>
                  <path
                    d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                    data-name="Icon ionic-ios-close"
                    opacity="0.3"
                    transform="translate(1534.289 132.789)"
                  ></path>
                </g>
              </svg>
            </Button>
          </ModalHeader>
          <ModalBody className="notification-blc">
            {console.log("notificationDetails", notificationDetails)}
            <h2>{notificationDetails?.title?.replace(/<[^>]+>/g, '')}</h2>
            <div className="desc-blc" style={{ wordWrap: 'break-word' }}>
              <p>
                <div dangerouslySetInnerHTML={{ __html: notificationDetails?.description }}>

                </div>
                {/* {notificationDetails?.description?.replace(/<[^>]+>/g, '')} */}
              </p>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};
export default Header;